import React from 'react'

interface Option {
  id: number
  title: string
  subTitle: string
  slug: string
}

interface RectangularTabsProps {
  options: Option[]
  selectedTab: number // Assuming this is the correct prop name
  handleTabChange: (id: number) => void
  isDisabled?: boolean
}

const RectangularTabs: React.FC<RectangularTabsProps> = ({
  options,
  selectedTab,
  handleTabChange,
  isDisabled = false,
}) => {
  return (
    <div
      style={{
        overflowX: 'auto', // Enable horizontal scrolling
        whiteSpace: 'nowrap', // Prevent wrapping
        padding: 0,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'nowrap',
          gap: '1rem', // Gap between tabs
          padding: '0.5rem 0', // Adjust padding as needed
        }}
      >
        {options.map(({ id, title, subTitle }) => (
          <button
            disabled={isDisabled}
            key={id}
            className={`d-flex flex-column options-container p-4 align-content-start cursor-pointer border border-muted ${selectedTab === id ? 'selected-option border-primary' : ' border-2'
              }`}
            style={{
              width: '200px',
              flex: '0 0 auto', // Prevent shrinking and wrapping
              display: 'inline-block',
            }}
            onClick={() => handleTabChange(id)}
          >
            <h1 className={`m-0 ${selectedTab !== id && isDisabled ? 'text-clrA1' : ''}`}>{title}</h1>
            <p className={`mt-2 text-muted`} style={{ whiteSpace: 'normal' }}>
              {subTitle}
            </p>
          </button>
        ))}
      </div>
    </div>
  )
}

export default RectangularTabs
